import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const BANNERS = [
  { 
    src: '/images/banner_1.jpg', 
    alt: 'Real-time insights. Stronger decisions. Accelerated growth — ChannelLoyalty.ai',
    cta1: '/contact',
    cta2: '/platform',
  },
  { 
    src: '/images/banner_2.jpg', 
    alt: 'One Platform. Every Stakeholder — ChannelLoyalty.ai',
    cta1: '/platform',
    cta2: '/solutions',
  },
  { 
    src: '/images/banner_3.jpg', 
    alt: 'Insights that power decisions — ChannelLoyalty.ai',
    cta1: '/ai-brain',
    cta2: '/contact',
  },
  { 
    src: '/images/banner_4.jpg', 
    alt: 'Turn Channel Engagement Into Revenue Growth — ChannelLoyalty.ai',
    cta1: '/contact',
    cta2: '/platform',
  },
];

export default function HeroBannerCarousel() {
  var currentState = useState(0);
  var current = currentState[0];
  var setCurrent = currentState[1];
  var transState = useState(false);
  var isTransitioning = transState[0];
  var setIsTransitioning = transState[1];

  var goTo = useCallback(function(index) {
    if (isTransitioning || index === current) return;
    setIsTransitioning(true);
    setCurrent(index);
    setTimeout(function() { setIsTransitioning(false); }, 600);
  }, [current, isTransitioning]);

  var next = useCallback(function() {
    goTo((current + 1) % BANNERS.length);
  }, [current, goTo]);

  useEffect(function() {
    var timer = setInterval(next, 5000);
    return function() { clearInterval(timer); };
  }, [next]);

  return (
    <div className="hero-banner-carousel" data-testid="hero-banner-carousel">
      <div className="hero-banner-track">
        {BANNERS.map(function(banner, i) {
          return (
            <div
              key={i}
              className={'hero-banner-slide' + (i === current ? ' active' : '')}
              data-testid={'banner-slide-' + i}
            >
              <img src={banner.src} alt={banner.alt} draggable={false} />
              <Link to={banner.cta1} className="hero-cta-hitbox hero-cta-hitbox-1" data-testid={'banner-cta1-' + i} aria-label="Primary CTA" />
              <Link to={banner.cta2} className="hero-cta-hitbox hero-cta-hitbox-2" data-testid={'banner-cta2-' + i} aria-label="Secondary CTA" />
            </div>
          );
        })}
      </div>
      <div className="hero-banner-dots" data-testid="banner-dots">
        {BANNERS.map(function(_, i) {
          return (
            <button
              key={i}
              className={'hero-banner-dot' + (i === current ? ' active' : '')}
              onClick={function() { goTo(i); }}
              aria-label={'Go to banner ' + (i + 1)}
              data-testid={'banner-dot-' + i}
            />
          );
        })}
      </div>
    </div>
  );
}
